module.exports = __webpack_public_path__ + "static/media/DOGE-USDC.bc0a28dc.svg";